function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "48.4,87.1 45.4,87.1 45.4,23.3 36.5,35.7 34.1,33.9 48.4,14.1  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "55.2,87.1 52.2,87.1 52.2,14.1 66.6,33.9 64.1,35.7 55.2,23.3  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "69,30.7 50.3,6.1 31.6,30.7 29.2,28.9 50.3,1.1 71.4,28.9  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "19.3,100.2 16.3,100.2 16.3,50.5 7.4,62.9 5,61.1 19.3,41.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "26.1,100.2 23.1,100.2 23.1,41.2 37.5,61.1 35,62.9 26.1,50.5  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "39.9,57.9 21.2,33.3 2.5,57.9 0.1,56 21.2,28.3 42.3,56  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "76.5,100.2 73.5,100.2 73.5,50.5 64.6,62.9 62.2,61.1 76.5,41.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "83.3,100.2 80.3,100.2 80.3,41.2 94.7,61.1 92.3,62.9 83.3,50.5  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "97.1,57.9 78.4,33.3 59.8,57.9 57.4,56 78.4,28.3 99.5,56  "
})))));

var SvgArrowsUp = function SvgArrowsUp(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrows-up.66632ebb.svg";
export { SvgArrowsUp as ReactComponent };